<template>
	<div style="height: 100%; position: relative;">
		<div
			id="d008"
			class=""
			style="position: absolute; top: 0; left: 0; right: 0; bottom: 40px;"
		></div>
		<div
			class="center"
			style="position: absolute; bottom: 0; left: 0; right: 0;"
		>
			<span class="dot primary"></span> {{ 'Nettoomsättning' | T }}
		</div>
	</div>
</template>

<script>
/* tslint:disable */
import Highcharts from "highcharts";
import Vue from "vue";
import { colors } from "@/config";

export default {
	name: "D008",
	components: {},
	props: {
		profitloss: Object,
	},

	mounted() {
		this.chart = new Highcharts.chart({
			chart: {
				type: "column",
				renderTo: "d008",
				backgroundColor: "transparent",
			},

			credits: {
				enabled: false,
			},

			title: {
				text: "",
			},

			legend: {
				enabled: false,
			},

			colors: [colors.Primary, colors.Tertiary],

			xAxis: {
				categories: this.profitloss.sheets
					.map((s) => s.DATE_TO.substr(0, 4))
					.reverse(),
				labels: {
					style: { fontSize: "1rem", color: colors.Black, },
				},
			},

			yAxis: [
				{
					opposite: true,
					allowDecimals: false,
					title: {
						text: "",
					},
					labels: {
						formatter() {
							return Vue.options.filters.KR(this.value);
						},
						style: { fontSize: "1rem", colors: colors.DarkGrey, },
					},
					tickPixelInterval: 150,
					gridLineColor: colors.LightGrey,
					plotLines: [{
						color: colors.Black,
						width: 2,
						value: 0,
						zIndex: 2,
					}]
				},
				{
					title: {
						text: Vue.prototype.$t("Rörelsemarginal"),
						style: {
							color: colors.Tertiary,
							fontSize: "1.2rem",
						},
					},
					labels: {
						format: "{value} %",
						style: {
							color: colors.Tertiary,
							fontSize: "1.2rem",
						},
					},
					max: 50,
					min: 0,
					tickPixelInterval: 150,
				},
			],

			tooltip: {
				formatter: function() {
					let p = this;
					return this.series.tooltipOptions.tooltip.call(p);
				},
				style: { fontSize: "1.25rem" },
				backgroundColor: colors.Light,
			},

			plotOptions: {
				column: {
					stacking: "normal",
					borderColor: colors.darkGrey,
				},
			},

			series: [
				{
					name: Vue.prototype.$t("Nettoomsättning"),
					data: this.profitloss.sheets
						.map((s, i) =>
							i === 0 ? { y: s.A, color: colors.Secondary } : s.A
						)
						.reverse(),
					tooltip: {
						tooltip: function() {
							return (
								"<b>" +
								this.series.name +
								"<br>" +
								Vue.options.filters.TKR(this.y)
							);
						},
					},
					stack: "intakt",
				},
				{
					name: Vue.prototype.$t("Rörelsemarginal"),
					type: "spline",
					yAxis: 1,
					data: this.profitloss.sheets
						.map((s, i) => (100 * s.K) / s.A)
						.reverse(),
					tooltip: {
						tooltip: function() {
							return (
								"<b>" +
								this.series.name +
								"<br>" +
								Vue.options.filters.D1(this.y) +
								"%"
							);
						},
					},
					dashStyle: "Dash",
				},
			],
		});
	},
};
</script>

<style scoped lang="scss">
.dot {
	height: 20px;
	width: 20px;
	border-radius: 50%;
	display: inline-block;
}

.primary {
	background: linear-gradient(
		-45deg,
		get("colors.Secondary"),
		get("colors.Secondary") 50%,
		get("colors.Primary") 50%
	);
	border-radius: 50%;
}

.result {
	background: linear-gradient(
		-45deg,
		col("colors.Negative"),
		col("colors.Negative") 50%,
		col("colors.Positive") 50%
	);
	border-radius: 50%;
}

.center {
	font-size: 1.2rem;
}
</style>
